import SETTINGS from '../../settings';

let logdna;

const LogDNA = {
  init: async () => {
    if (typeof window === 'object') {
      if (!logdna) {
        try {
          const module = await import('@logdna/browser');
          logdna = module.default;
        } catch (e) {
          console.error('Logdna module load error');
        }
      }

      if (!window.__LogDNA__ && logdna) {
        logdna.init(SETTINGS.SCRIPTS.LOGDNA_INGESTION_KEY, {
          globalErrorHandlers: {
            enableErrorHandler: true,
            enableUnhandledPromiseRejection: false,
          },
          hostname: `${SETTINGS.APP_NAME}-nextjs`,
        });
      }
    }
  },
};

export default LogDNA;
